import React, { Component } from 'react';
import { FormGroup, Col } from 'react-bootstrap';
import { checkDDL, generateURL } from '../../utils/helper';
import axios from '../../utils/axiosClient';

class APISelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
    };
  }

  setServer = (e) => {
    axios.defaults.baseURL = e.target.value;
  };

  UNSAFE_componentWillMount() {
    const GENERIC_URL = generateURL();
    axios.defaults.baseURL = `${GENERIC_URL}/`;
    if (checkDDL()) {
      this.setState({ isShow: true });
    }
    console.log('CheckDDL: ' + checkDDL());
  }

  render() {
    return this.state.isShow ? (
      <FormGroup controlId="formHorizontalUserId">
        <Col sm={12}>
          <select className="form-control" onChange={this.setServer.bind(this)}>
            <option value="http://uatapi.orxa.io/api">OrxaionewDB</option>
            <option value="http://apiakola.orxa.io/api/">MSEDCLDB</option>
            <option value="http://qaapi.orxa.io/api/">qaorxaionew</option>
          </select>
        </Col>
      </FormGroup>
    ) : null;
  }
}

export default APISelector;
